<template>
  <div>
    <modal
      size="small"
      :hideCloseButton="closeButton"
      v-if="visible"
      @close-modal="closeModal"
    >
      <div slot="header">
        Deseja remover o usuário da organização?
      </div>
      <div class="container" slot="content">
        <div>
          Nome: {{ usuario.nome }} <br>
          Email: {{ usuario.email }}
        </div>
        <form id="form-token" v-on:submit.prevent="onSubmit">
          <div class="form-box form-creditos">
            <button :disabled="submited" type="submit" class="btn danger-background -full _mt">
              <b>Remover Usuário</b>
            </button>
          </div>
        </form>
        <span class="Message -fail" v-text="this.form.errors.data"></span>
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "RemoverUsuarioOrganizacaoModal",
  props: {
    visible: Boolean,
    usuario: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      closeButton: true,
      submited: false,
      form: new Form({})
    };
  },
  methods: {
    onSubmit: function() {
      this.submited = true;

      EventBus.$emit('loading-show');

      axios({
        method: "delete",
        url: "organizacao/remover-usuario/"+this.usuario.id,
      })
        .then(response => {
          EventBus.$emit('loading-hide');
          window.location.reload();
        })
        .catch(error => {
          this.submited = false;

          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
    closeModal: function() {
      this.$emit("closeModal");
    }
  }
}
</script>

<style scoped>

</style>
